import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Copy, Download } from 'lucide-react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import sampleTag from './sample-tag';
import { Order } from '../../types/order';
import { format } from 'date-fns';

interface ModalOrderTagProps {
    isOpen: boolean;
    toggle: () => void;
    order: Order;
}

const ModalOrderTag: React.FC<ModalOrderTagProps> = ({ isOpen, toggle, order }) => {
    const [codeString, setCodeString] = useState<string>('');

    useEffect(() => {
        updateCodeString(order);
    }, [order]);

    const updateCodeString = (order: Order) => {
        const campaign = order.campaign;
        const replacements = {
            '[ID_PEDIDO]': String(order.id),
            '[ID_CAMPANHA]': String(campaign?.id),
            '[NOME_CAMPANHA]': campaign?.name,
            '[NOME_AGENCIA]': campaign?.agency?.name,
            '[NOME_VEICULO]': order.site?.publisher?.name,
            '[NOME_CLIENTE]': campaign?.advertiser?.name,
            '[SEGMENTACAO]': order.segmentation,
            '[LINHA_CRIATIVA]': order.creativeLine,
            '[REGIAO]': 'NACIONAL',
            '[NOME_FORMATO]': order.placement?.name,
            '[TAMANHO_FORMATO]': order.sizes.join(', '),
            '[DATA_INICIO]': format(new Date(order.startDate), 'dd/MM/yyyy'),
            '[DATA_TERMINO]': format(new Date(order.endDate), 'dd/MM/yyyy'),
        };
        const text = Object.entries(replacements).reduce(
            (acc, [key, value]) => acc.replaceAll(key, value || ''),
            sampleTag,
        );
        setCodeString(text);
    }

    const downloadTag = () => {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(codeString));
        element.setAttribute('download', `${order.id} - AD PULSE TAG.txt`);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    return (
        <Dialog open={isOpen} onOpenChange={toggle}>
            <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>TAG</DialogTitle>
                    <DialogDescription>
                        Insira a TAG abaixo no creative do seu Ad Manager.
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-4">
                    <div className="relative">
                        <SyntaxHighlighter language="xml" style={docco}>
                            {codeString}
                        </SyntaxHighlighter>
                        <div className="absolute top-2 right-2 flex gap-2">
                            <Button
                                type="button"
                                variant="outline"
                                size="sm"
                                onClick={() => navigator.clipboard.writeText(codeString)}
                            >
                                <Copy className="h-4 w-4" />
                            </Button>
                            <Button
                                type="button"
                                variant="outline"
                                size="sm"
                                onClick={downloadTag}
                            >
                                <Download className="h-4 w-4" />
                            </Button>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ModalOrderTag;